import axios from "axios";
import vue from "../main";
import Cookie from "js-cookie";
import { GetAuthToken } from "rj-server-auth-token";
import {
  handleAxiosAndRouterToken,
  PARTNERS_TOKEN,
  removeAllCookie,
  toLogin
} from "../utils/loginUtils";
// 接口白名单
const whiteList = ["/partners-center-admin/userAuthority/token/generate"];
// 不再限制到一个服务
let Api = axios.create({
  baseURL: window._env_.BASE_APIS,
  withCredentials: true,
  headers: {
    sysId: "be7b21f00c034675a75a270257275f24"
  }
});
// http请求拦截
Api.interceptors.request.use(
  async config => {
    // 请求白名单
    if (!whiteList.includes(config.url)) {
      await handleAxiosAndRouterToken();
      // 这个地方的时候必有token
      config.headers["token"] = Cookie.get(PARTNERS_TOKEN);
    }

    config.headers["web-sign-server-auth"] = GetAuthToken({
      sysId: "be7b21f00c034675a75a270257275f24",
      accessKeySecret: "9174A3DE0A8940E2B1741324FBA75339"
    });

    if (config.method === "get") {
      config.params = {
        ...config.params,
        _t: Date.parse(new Date()) / 1000
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// http响应拦截器
Api.interceptors.response.use(
  res => {
    switch (res.data.status) {
      case "200":
        break;
      case "10001":
        vue.$notify({
          message: vue.$createElement(
            "div",
            res.data.err
              .split(/\n/)
              .map(item => vue.$createElement("div", item))
          ),
          type: "error"
        });
        break;
      case "403":
        removeAllCookie();
        toLogin();
        break;
      case "88888":
        window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
          window.location.href
        )}`;
        break;
      default:
        if (res.data.err) {
          vue.$notify({
            title: res.data.err,
            type: "error"
          });
        }
    }
    return res.data;
  },
  async error => {
    if (error.response && error.response.status === 403) {
      removeAllCookie();
      toLogin();
    } else if (error.response) {
      vue.$notify.error(error.response.data.err);
    } else {
      vue.$notify.error("系统异常");
    }
  }
);

// 用cookies获取token
export const postGenerate = params =>
  Api.post(`/partners-center-admin/userAuthority/token/generate`, params);
// 清除token的状态等于这个Token在后端校验服务中直接失效
export const cleanToken = token =>
  Api.get(`/partners-center-admin/userAuthority/token/cleanToken`, {
    params: { token }
  });

/**
 * 2025EBG发起签约
 * @param {*} params
 * @returns
 */
export const createContractEbg = params =>
  Api.post("/partners-customer-service/contract25/createContractEbg", params);

/**
 * 2025EBG续签获取合同详情
 * @param {*} params
 * @returns
 */
export const getContractDetails = documentId =>
  Api.post(
    `/partners-customer-service/contract25/getContractDetails?documentId=${documentId}`
  );

/**
 * 2025EBG续签获取合同详情(脱敏)
 * @param {*} params
 * @returns
 */
export const getCurrencyContractDetails = documentId =>
  Api.post(
    `/partners-customer-service/currency/contract25/getContractDetails?documentId=${documentId}`
  );

/**
 * 2025EBG续签
 * @param {*} params
 * @returns
 */
export const renewContractEbg = params =>
  Api.post("/partners-customer-service/contract25/renewContractEbg", params);

/**
 * 2025EBG审批流程
 * @param {*} params
 * @returns
 */
export const approvalProcess = params =>
  Api.post("/partners-customer-service/contract25/approvalProcess", params);

/**
 * 获取流程节点
 * @param {*} documentId
 * @returns
 */
export const getProcessNodes = documentId =>
  Api.get(
    `/partners-customer-service/contract25/getProcessNodes?documentId=${documentId}`
  );

// export const approvalProcess = (params) => Api.post('/partners-customer-service/contract25/approvalProcess', params)
/**
 * EBG 编辑
 * @param {*} params
 * @param {*} cancel
 * @returns
 */
export const editContract = (params, cancel) =>
  Api.post("/partners-customer-service/contract25/edit", params, {
    cancelToken: new axios.CancelToken(function executor(c) {
      // 这个 executor 函数接收一个 cancel 函数作为参数
      cancel && cancel(c);
    })
  });

// /**
//  * 获取Members
//  * @param {*} masterAccount
//  * @returns
//  */
export const getAccountByMasterNotReject = (masterAccount, partnerType) =>
  Api.get(
    `/partners-customer-service/account/getAccountByMasterNotReject?masterAccount=${masterAccount}&state=1&pageNum=1&pageSize=999&partnerType=${partnerType}`
  );

export const getAccountByMasterNotRejectCurrency = (masterAccount, partnerType) =>
    Api.get(
      `/partners-customer-service/currency/account/getAccountByMasterNotReject?masterAccount=${masterAccount}&state=1&pageNum=1&pageSize=999&partnerType=${partnerType}`
    );



// WEBPACK FOOTER //
// ./src/api/EBGTwentyTwentyFive.js